"use client";

import { usePathname } from "next/navigation";
import Footer from "./footer"; // Adjust the import path as needed

export default function ClientFooter() {
  const pathname = usePathname();

  // Check if pathname contains "design"
  if (
    pathname.includes("design") ||
    pathname.includes("customize") ||
    pathname.includes("weddingwebsite") ||
    pathname.includes("invite") ||
    pathname.includes("demos")
  ) {
    return null;
  }
  // if (pathname.includes("slashslash")) {
  //   return null;
  // }
  console.log(pathname);

  return <Footer />;
}
